import React, {Component} from "react";
import Card from "../../../components/Card/Card";
import {request} from "../../../api-client";
import moment from "moment";
import {makeFitImageUrlWithSize, setStatePromise} from "../../../utils";
import {Fullscreen, VolumeOff} from "@material-ui/icons";
import {IconButton} from "@material-ui/core";
import './Livestream.css'
import styled from "styled-components";
import Vimeo from "@vimeo/player"
import browserHistory from "../../../utils/browserHistory";
import {homePathGenerator, GAevent, slugify} from "../../../api-client/core/authentication/utils";

export default class extends Component {
  constructor(props) {
    super(props);

    this.state = {
      livestream: null,
      showOpeningImage: false,
      showEndImage: false,
      timeDiff: 0,
      muted: false,
      fullscreen: false,
      loaded: false,
    };

    this.refVimeoPlayer = null;
    this.setVimeoPlayer = element => {
      this.refVimeoPlayer = element
      this.setState({})
    }
}

  componentDidMount = () => {
    this.interval = setInterval(this.sendTracking, 15000);
    document.getElementsByTagName('html')[0].scrollTop = 0
    this.setLivestream()
      .then((livestream) => {
        this.setState({livestream: livestream ? livestream : this.props.location.state.livestream})
      })
      .then(() => GAevent('Contenido', "Play", this.state.livestream.fake ? `Estreno: ${this.state.livestream.name}` : `Vivo: ${this.state.livestream.name}`))
      .then(() => this.processLivestreamStartTime(this.state.livestream))
      .then(() => this.setState({loaded: true}))


    document.addEventListener('fullscreenchange', this.handleEscapeKeyPress);
    document.addEventListener('webkitfullscreenchange', this.handleEscapeKeyPress);
    document.addEventListener('mozfullscreenchange', this.handleEscapeKeyPress);
    document.addEventListener('MSFullscreenChange', this.handleEscapeKeyPress);
  };

  componentWillUnmount = () => {
    document.removeEventListener('fullscreenchange', this.handleEscapeKeyPress);
    document.removeEventListener('webkitfullscreenchange', this.handleEscapeKeyPress);
    document.removeEventListener('mozfullscreenchange', this.handleEscapeKeyPress);
    document.removeEventListener('MSFullscreenChange', this.handleEscapeKeyPress);
    document.removeEventListener('mouseover', this.forceAutoplay)
    clearInterval(this.interval);
  }

  setLivestream = () => {
    if (!this.props.location.state) {
      return request.liveStream.get(this.props.match.params.livestreamId)
    } else {
      return new Promise(resolve => {
        resolve()
      })
    }
  }

  sendTracking = () => {
    if(!this.state.showOpeningImage && !this.state.showEndImage) {
      GAevent('Contenido', "Video_Tracking", this.state.livestream.fake ? `Estreno: ${this.state.livestream.name}` : `Vivo: ${this.state.livestream.name}`, 15)
    }
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   if (prevProps.location.pathname !== this.props.location.pathname && !this.props.preview) {
  //     this.state.livestream && GAevent('Contenido', "Play", this.state.livestream.fake ? `Estreno: ${this.state.livestream.name}` : `Vivo: ${this.state.livestream.name}`)
  //     this.processLivestreamStartTime(this.state.livestream)
  //       .then(() => this.setState({loaded: true}))
  //   }
  // }

  processLivestreamStartTime = (livestream) => {
    if (!this.props.preview) {
      let timeDiff = moment().diff(moment.utc(livestream.start_time).local(), "seconds")
      let timeDiffToEnd = moment().diff(moment.utc(livestream.end_time).local(), "seconds")

      console.log(timeDiff, timeDiffToEnd )

      if (timeDiff < 0 ) {
        this.setState({showOpeningImage: true},
          () => {
            setTimeout(() => {
              clearInterval(this.countdown);
              this.setState({showOpeningImage: false})
            }, Math.abs(timeDiff * 1000))

            if (!livestream.startImage) {
              this.setCountdown(livestream)
              this.countdown = setInterval(() => this.setCountdown(livestream), 10000)
            }
          })
      } else {
        this.setState({timeDiff})
      }

      if (livestream.contentCreator && timeDiffToEnd > 0) {
        browserHistory.push(homePathGenerator(`contenido/${livestream.contentCreator.id}-${slugify(livestream.contentCreator.name)}`))
      }

    if (livestream.source === 'youtube' || livestream.source === 'vimeoLive') {
      if (timeDiffToEnd < 0) {
        setTimeout(() => this.handleEndVideoEvents(),
          Math.abs(timeDiffToEnd*1000))
      } else {
        this.handleEndVideoEvents()
      }
    }

    } else {
      this.setState({})
    }

    return new Promise(resolve => {
      resolve()
    })
  }

  forceAutoplay = () => {
    this.videoRef.play()
      .catch(() => this.setState({muted: true}))
  }

  setCountdown = (livestream) => {
    let difference = moment.utc(livestream.start_time).local().diff(moment(), "minutes");
    // Output the result
    let countdownElement = document.getElementById("countdown")
    if (countdownElement)  {
      countdownElement.innerHTML = difference + 1;
    }
    return difference
  }

  play = () => {
    this.toggleVideoState(true, 'play', 'onPlay')
  }

  pause = () => {
    this.toggleVideoState(false, 'pause', 'onPause')
  }

  unmute = () => {
    this.videoRef.muted = false
    this.setState({muted: false})
  }

  fullScreen = () => {
    if (!/iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {

      if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        document.getElementById("live-container").requestFullscreen()
          .then(() => this.setState({fullscreen: true}))
      } else {
        document.exitFullscreen()
          .then(() => this.setState({fullscreen: false}))
      }

    }
  }

  handleEscapeKeyPress = () => {
    if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
      this.setState({fullscreen: false})
    }
  }

  toggleVideoState = (toPlayingState, action, event) => {
    if (this.state.playing === toPlayingState) {
      return
    }

    this.setState({ playing: toPlayingState })
    this.videoRef[action]()
  }

  playOrPause = () => {
    if (document.getElementById("video").paused) {
      this.play()
    } else {
      this.pause()
    }
  }

  resetState = () => {
    return setStatePromise(this, {
      livestream: null,
      showOpeningImage: false,
      showEndImage: false,
      timeDiff: 0,
      muted: false,
      fullscreen: false,
      loaded: false,
    })
  }

  fetchNextLivestream = () => {
    return request.liveStream.checkIfActive()
      .then(livestreams => {
        if (livestreams.length > 1 || (livestreams.length === 1 && livestreams[0].id !== this.state.livestream.id)) {
          browserHistory.push(homePathGenerator(`vivos`))
        }
      })
  }


  handleEndVideoEvents = () => {
    this.setVimeoPlayer(null)
    this.setState({showEndImage: true}, () => {
      if (!this.props.preview) {
        this.fetchNextLivestream()
      }
    })
  }

  //makeUrl = () => 'https://vimeo.com/474019351'

  makeUrl = () => `https://www.youtube.com/embed/live_stream?channel=${this.state.livestream.stream_id}&autoplay=1&modestbranding=1&rel=0`

  makeFakeUrl = (livestream) => livestream.video.url + `#t=${this.state.timeDiff}`

  renderVimeo = () => {
    let videoId = this.state.livestream.stream_id.split('/')
    let options = {
      id: videoId[videoId.length - 1],
      width: window.innerWidth*0.799,
      height: window.innerHeight*0.8,
      loop: false,
      autoplay: true,
    }

    const player = new Vimeo('vimeo-player', options);

    player.on('ended', () => {
      console.log('Ended the video');
      this.handleEndVideoEvents()
    });

    if (this.state.livestream.fake && !this.props.preview) {
      player.getDuration().then(duration => {
        if (this.state.timeDiff < duration) {
          player.setCurrentTime(this.state.timeDiff)
        } else {
          player.setCurrentTime(duration)
        }
      })
    }
  }

  render = () => {
    const {loaded, livestream, showOpeningImage, showEndImage} = this.state

    if (loaded) {
      return (
        <div style={{display: 'flex', alignItems: 'center', marginTop: 50}}>
          <Card style={{alignItems: "center", boxShadow: 'none', margin: 0}}>
              <LiveContainer id="live-container" className="live-container" style={{ width: window.innerWidth*0.8, height: window.innerHeight*0.8}}>
                {!showOpeningImage && !showEndImage &&
                ((livestream.source === 'vimeo' || livestream.source === 'vimeoLive') ?
                  <>
                    <div id='vimeo-player' ref={this.setVimeoPlayer}></div>
                    {this.refVimeoPlayer && this.renderVimeo()}
                  </>
                : livestream.source === 'youtube' ?
                  <iframe width={window.innerWidth*0.8} height={window.innerHeight*0.8} src={this.makeUrl()} allow="autoplay" frameBorder="0" allowFullScreen/>
                :
                  <>
                    <div className="live-controls" style={{display: 'none'}}>
                      <span style={{ position: 'absolute', color: 'white', zIndex: 2, left: 10, top: 5}}>{livestream.name}</span>
                      {this.state.muted &&
                      <IconButton onClick={() => this.unmute()} style={{height: 40, width: 30, right: 35, position: 'absolute', zIndex: 2}}>
                        <VolumeOff style={{fontSize: "25px", color: "white"}}/>
                      </IconButton>
                      }
                      <IconButton onClick={() => this.fullScreen()} style={{height: 40, width: 30, right: 5, position: 'absolute', zIndex: 2}}>
                        <Fullscreen style={{fontSize: "25px", color: "white"}}/>
                      </IconButton>
                    </div>
                    <video
                      id="video"
                      ref={ref => this.videoRef = ref}
                      style={{
                        width: "99.9%",
                        height: "100%",
                      }}
                      src={this.makeFakeUrl(livestream)}
                      autoPlay
                      onCanPlay={() => document.addEventListener('mouseover', this.forceAutoplay)}
                      onEnded={() => {this.handleEndVideoEvents(); document.removeEventListener('mouseover', this.forceAutoplay)}}
                      onPlaying={() => document.removeEventListener('mouseover', this.forceAutoplay)}
                      onDoubleClick={() => this.fullScreen()}
                      onClick={() => this.playOrPause()}
                      muted={this.state.muted}
                      onContextMenuCapture={(event) => {event.preventDefault(); return false}}
                    />
                  </>
                )}
                {showOpeningImage && livestream.startImage &&
                <Img
                  alt="opening_image"
                  src={makeFitImageUrlWithSize({image: livestream.startImage}, 'lg')}/>
                }
                {showOpeningImage && !livestream.startImage &&
                <h3 style={{color: 'white'}}>El vivo comenzará en <span id="countdown"></span> minutos</h3>
                }
                {showEndImage && livestream.endImage &&
                <Img
                  alt="end_image"
                  src={makeFitImageUrlWithSize({image: livestream.endImage}, 'lg')}/>
                }
              </LiveContainer>
          </Card>
        </div>
      )
    } else {
      return <div></div>
    }

  }
}

const LiveContainer = styled.div`
  background-color: black;
  text-align: center;
@media (max-width: 500px) {
   width: 100vw!important;
}
`;

const Img = styled.img`
  height: 100%;
  width: auto;
@media (max-width: 500px) {
    object-fit: contain;
    width: 100%;
}
`;

